import { useParams } from "react-router-dom";

export function useBookingIdParam() {
    const { bookingId } = useParams();
    return bookingId ?? "";
}
